import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Box,
  Typography,
} from '@mui/material';
import { Cell } from '@m4a3/api-client';

interface CellSelectorProps {
  cells: Cell[];
  selectedCellId: number | null;
  onCellChange: (cellId: number) => void;
  disabled?: boolean;
}

const CellSelector: React.FC<CellSelectorProps> = React.memo(({
  cells,
  selectedCellId,
  onCellChange,
  disabled = false
}) => {
  const handleChange = (event: SelectChangeEvent<number>) => {
    const cellId = event.target.value as number;
    onCellChange(cellId);
  };

  if (!cells || cells.length === 0) {
    return (
      <Box sx={{ width: 200, display: 'flex', alignItems: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Loading cells...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: 200 }}>
      <FormControl fullWidth size="small" disabled={disabled}>
        <InputLabel id="cell-selector-label">Cell</InputLabel>
        <Select
          labelId="cell-selector-label"
          id="cell-selector"
          value={selectedCellId || ''}
          label="Cell"
          onChange={handleChange}
        >
          {cells
            .sort((a, b) => (a.displayName || a.cellName).localeCompare(b.displayName || b.cellName))
            .map((cell) => (
              <MenuItem key={`cell-${cell.id}`} value={cell.id}>
                {cell.displayName || cell.cellName}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
});

CellSelector.displayName = 'CellSelector';

export default CellSelector;
